import React, { useEffect, useState, useRef } from "react";
import { PiUserGearLight, PiUserPlusLight } from "react-icons/pi";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { API_URL, NODE_ENV } from "../../utils/constants";
import commonActions from "../../redux/common/actions";
import { io } from "socket.io-client";
import { useDispatch, useSelector } from "react-redux";
import GreenButton from "../../common/button/greenButton";
import xlsx from "json-as-xlsx";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import xlsxpng from "../../assets/images/uploads/xlsx.png";
import { PiXBold } from "react-icons/pi";
import { IoCloudUploadOutline } from "react-icons/io5";
import {
  Box,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Menu,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { cssProperties } from "../../utils/commonCssProperties";
import generateAdmitcardActions from "../../redux/admitcardgeneration/action";
import masterActions from "../../redux/master/actions";
import BluePrimaryButton from "../../common/button/bluePrimaryButton";

export default function Index() {
  const dispatch = useDispatch();
  const socketRef = useRef(null);
  const [open, setOpen] = useState({ open: false, type: null });
  const [intervalId, setIntervalId] = useState(null);
  const [file, setFile] = useState(null);
  const [isLogicApplied, setIsLogicApplied] = useState("0");
  const [statusModalopen, setStatusModalOpen] = useState({
    open: false,
    statustext: "",
  });
  const [loading, setLoading] = useState(false);
  const { courseList } = useSelector((state) => state.masterReducer);
  const [id, setId] = useState(0);
  const { coursecandidatelist } = useSelector((state) => state.masterReducer);
  // const admitCardGeneratedCount = coursecandidatelist?.reduce(
  //   (count, candidate) =>
  //     candidate.isadmitcardgenerated === "1" ? count + 1 : count,
  //   0
  // );
  const admitCardGeneratedCount = coursecandidatelist?.reduce(
    (count, candidate) =>
      candidate.rollno != null && candidate.isadmitcardgenerated === "1"
        ? count + 1
        : count,
    0
  );
  const admitCardNotGeneratedCount = coursecandidatelist?.reduce(
    (count, candidate) =>
      candidate.rollno != null && candidate.isadmitcardgenerated === "0"
        ? count + 1
        : count,
    0
  );
  const fixAdmitCardUrl = (url) => {
    const base = url.split('.pdf')[0];
    return `${base}.pdf`;
  };

//   const handleDownloadZip = async () => {
//     if (coursecandidatelist.length === 0) return alert('No candidates found!');
//     setLoading(true);

//     const zip = new JSZip();

//     // for (const candidate of coursecandidatelist) {
//     //   const fixedUrl = fixAdmitCardUrl(candidate.admitcardurl);
//     //   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

//     //   try {
//     //     const response = await axios.get(fixedUrl, { responseType: 'blob' });
//     //     zip.file(fileName, response.data);
//     //   } catch (error) {
//     //     console.error(`Failed to download ${fileName}:`, error);
//     //   }
//     // }
// for (const candidate of coursecandidatelist) {
//   const fixedUrl = fixAdmitCardUrl(candidate.admitcardurl);
//   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

//   try {
//     const response = await axios.get(fixedUrl, { responseType: 'blob' });

//     const contentType = response.headers['content-type'];
//     if (contentType !== 'application/pdf') {
//       console.warn(`Skipping ${fileName}: not a PDF (got ${contentType})`);
//       continue;
//     }

//     zip.file(fileName, response.data);
//   } catch (error) {
//     console.error(`Failed to download ${fileName}:`, error);
//   }
// }

//     zip.generateAsync({ type: 'blob' }).then((blob) => {
//       saveAs(blob, 'AdmitCards.zip');
//       setLoading(false);
//     });
//   };
const handleDownloadZip = async () => {
  dispatch({
    type: generateAdmitcardActions.GET_INTERNAL_ZIPFILE,
    payload: {
      courseid: id,
    },
  });
  // if (!coursecandidatelist.length) return;

  // setLoading(true);
  // const zip = new JSZip();

  // for (const candidate of coursecandidatelist) {
  //   const fileUrl = candidate.admitcardurl; // ✅ use full URL as-is
  //   const fileName = `${candidate.candidatename}_${candidate.rollno}.pdf`;

  //   try {
  //     const response = await fetch(fileUrl);
  //     if (!response.ok) {
  //       console.warn(`Skipping ${fileName}: HTTP ${response.status}`);
  //       continue;
  //     }

  //     const blob = await response.blob();
  //     zip.file(fileName, blob);
  //   } catch (error) {
  //     console.error(`Failed to fetch ${fileName}:`, error);
  //   }
  // }

  // zip.generateAsync({ type: 'blob' }).then((content) => {
  //   saveAs(content, 'AdmitCards.zip');
  //   setLoading(false);
  // });
};

  useEffect(() => {
    setFile(null);
    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: id,
        candidateid: 0,
      },
    });
  }, [isLogicApplied]);
  const toggleOpen = (type) => {
    setOpen({
      open: !open.open,
      type: type,
    });
  };
  const handleLogicAppliedChange = (e) => {
    setIsLogicApplied(e.target.value);
  };
  const handleDocumentUpload = (e) => {
    const file = e.target.files[0] || e.dataTransfer.files[0];
    setFile(file);
  };
  const handleUploadTemplate = () => {
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy"; // Show the copy cursor when dragging
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDocumentUpload(e);
  };
  const handleUploadCandidateData = () => {
    dispatch({
      type: generateAdmitcardActions.GENERATE_ADMIT_CARD,
      payload: {
        courseid: id,
        getDataInterval: getDataInterval,
        setIntervalId: setIntervalId,
        setStatusModalOpen: setStatusModalOpen,
        file: file,
      },
    });
    // if (courseId && file) {
    //   dispatch({
    //     type: scorecardActions.UPLOAD_CANDIDATE_DATA,
    //     payload: {
    //       courseid: courseId,
    //       id: backofficeTokenDetails?.id,
    //       isExternalData: isExternalData,
    //       file,
    //       setOpen,
    //       setLoading,
    //       getDataInterval: getDataInterval,
    //       setIntervalId: setIntervalId,
    //       setStatusModalOpen: setStatusModalOpen,
    //       setFile,
    //     },
    //   });
    // }
  };
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
  }, [dispatch]);
  const handleChange = (event) => {
    setId(event.target.value);
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: true });
    dispatch({ type: masterActions.SET_COURSE_CANDIDATE_LIST, payload: [] });

    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: event.target.value,
        candidateid: 0,
      },
    });
    dispatch({ type: commonActions.SET_PAGE_LOADER, payload: false });
  };

  let data = [
    {
      sheet: "Admitcard Generation Template",
      columns: [{ label: "rollno" }],
      content: [],
    },
  ];

  let settings = {
    fileName: "Admitcard Generation template",
    extraLength: 3,
    writeMode: "writeFile",
    writeOptions: {},
    RTL: false,
  };

  let callback = function (sheet) {
  };

  let getDataInterval = (logid) => {
    let intervalId = setInterval(() => {
      socketRef?.current?.emit("listenadmitcardstatus", { logid });
    }, 1000);
    return intervalId;
  };
  useEffect(() => {
    socketRef.current = io(
      `${API_URL}`,
      NODE_ENV === "production" && {
        path: "/api/socket.io",
        //     transports: ['websocket', 'polling'],
        // reconnection: true,
        // reconnectionAttempts: 5,
        // reconnectionDelay: 1000
      }
    );
    return () => (socketRef.current = null);
  }, []);
  useEffect(() => {
    socketRef?.current?.on("listengetadmitcardmessage", (message) => {
      // let data = message?.data
      if (message?.statusCode === 200) {
        let statustext = message?.data?.trim();
        if (
          statustext !=
          "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
        ) {
          if (statustext?.toLowerCase() !== "completed") {
            setStatusModalOpen({
              open: true,
              statustext:
                statustext?.trim() !== "" && statustext !== null
                  ? statustext
                  : statusModalopen.statustext,
            });
          } else {
            setStatusModalOpen({
              open: false,
              statustext:
                statustext?.toLowerCase() !== "completed"
                  ? ""
                  : statusModalopen.statustext,
            });

            clearInterval(intervalId);
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "success",
                show: true,
                message: "Admitcard Generated successfully",
              },
            });
            dispatch({
              type: masterActions.GET_COURSE_CANDIDATE_LIST,
              payload: {
                courseid: id,
                candidateid: 0,
              },
            });
            setTimeout(function () {
              dispatch({
                type: commonActions.SET_ALERT,
                payload: {
                  status: "success",
                  show: false,
                  message: null,
                },
              });
            }, 2000);
            setOpen({
              open: false,
              type: "candidate",
            });
          }
        } else {
          clearInterval(intervalId);
          dispatch({
            type: commonActions.SET_ALERT,
            payload: {
              status: "failed",
              show: true,
              message:
                statustext ==
                "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  ? "Failed to generate admitcard.You can continue this process after allocating venue and generating roll number"
                  : "Failed",
            },
          });
          dispatch({
            type: masterActions.GET_COURSE_CANDIDATE_LIST,
            payload: {
              courseid: id,
              candidateid: 0,
            },
          });
          setTimeout(function () {
            dispatch({
              type: commonActions.SET_ALERT,
              payload: {
                status: "failed",
                show: false,
                message: null,
              },
            });
          }, 2000);
          setStatusModalOpen({
            open: false,
            statustext: "",
          });
        }
      }
    });
    return () => socketRef?.current?.off("listenmessage");
  }, [dispatch, intervalId, socketRef]);
  const GenerateAdmitCard = () => {
    dispatch({
      type: generateAdmitcardActions.GENERATE_ADMIT_CARD,
      payload: {
        courseid: id,
        getDataInterval: getDataInterval,
        setIntervalId: setIntervalId,
        setStatusModalOpen: setStatusModalOpen,
        file: file,
      },
    });
  };
  const handleReset = () => {
    dispatch({
      type: generateAdmitcardActions.DELETE_ADMIT_CARD,
      payload: { courseid: id },
    });
    dispatch({
      type: masterActions.GET_COURSE_CANDIDATE_LIST,
      payload: {
        courseid: id,
        candidateid: 0,
      },
    });
  };

  return (
    <div>
      <Grid
        item
        md={7}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          flexWrap: "nowrap",
        }}
      >
        <FormControl sx={{ minWidth: 200, maxWidth: 250 }}>
          <Select
            size="small"
            value={id}
            onChange={handleChange}
            sx={{
              width: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <MenuItem value={0}>Courses</MenuItem>
            {courseList?.all?.map((course, i) => (
              <MenuItem
                key={i}
                value={course?.courseid}
                sx={{ whiteSpace: "nowrap" }}
              >
                {course?.coursename}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <BluePrimaryButton
          title={"Generate AdmitCard"}
          handleSubmit={GenerateAdmitCard}
          disabled={
            id == 0 ||
            coursecandidatelist?.length == 0 ||
            coursecandidatelist?.[0]?.templatedocs == null ||
            coursecandidatelist?.[0]?.isadmitcardgenerated == 1 ||
            isLogicApplied == 1
          }
        />
        <BluePrimaryButton
          title={"Reset"}
          handleSubmit={handleReset}
          disabled={
            id == 0 ||
            coursecandidatelist?.length == 0 ||
            coursecandidatelist?.[0]?.isadmitcardgenerated == 0 ||
            coursecandidatelist?.[0]?.templatedocs == null
          }
        />
        <MauvelousPrimaryButton
          handleClick={() => xlsx(data, settings, callback)}
          title="Download Template"
          disabled={!id || isLogicApplied == 0}
        />
        <MauvelousPrimaryButton
          handleClick={() => {
            if (id) {
              toggleOpen("candidate");
            }
          }}
          disabled={!id || isLogicApplied == 0}
          title=" Upload Rollno Data"
        ></MauvelousPrimaryButton>
                <MauvelousPrimaryButton
          handleClick={handleDownloadZip}
          disabled={!id || coursecandidatelist?.length == 0}
          title=" Download Admit Cards ZIP"
        ></MauvelousPrimaryButton>
      </Grid>
      <Grid item md={3} mt={2}>
        <FormControl>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Is partial or whole Generation
          </FormLabel>
          <RadioGroup
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            value={isLogicApplied}
            onChange={handleLogicAppliedChange}
            row
          >
            <FormControlLabel
              value="1"
              control={<Radio />}
              label="Partial Generation"
            />
            <FormControlLabel
              value="0"
              control={<Radio />}
              label="Whole Generation"
            />
          </RadioGroup>
        </FormControl>

     
      </Grid>
      {id > 0 && (
        <>
          {coursecandidatelist?.length > 0 && (
            <TableContainer>
              <Table style={{ marginTop: "3px" }}>
                <TableBody>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Total candidates for this course
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {coursecandidatelist?.length}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Admit cards already generated
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {admitCardGeneratedCount}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell style={{ border: "1px solid black" }}>
                      Yet to generate admit cards
                    </TableCell>
                    <TableCell style={{ border: "1px solid black" }}>
                      {" "}
                      {admitCardNotGeneratedCount}
                      {/* {coursecandidatelist?.length - admitCardGeneratedCount ==
                      NaN
                        ? 0
                        : coursecandidatelist?.length - admitCardGeneratedCount} */}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </>
      )}
      <Modal
        open={open.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
          }}
        >
          {file ? (
            <Box
              pl={2}
              style={{
                width: "fit-content",
                // maxWidth: "18em",
                height: "45px",
                border: "1px solid #D5D5D5",
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                marginTop: "1rem",
                paddingLeft: "0",
                // overflow: "hidden",
                // whiteSpace: "nowrap",
                // position: 'relative'
              }}
            >
              <img
                src={xlsxpng}
                style={{ height: "auto", width: "30px", marginLeft: "5px" }}
                alt="xlsx"
              />
              <Box sx={{ paddingLeft: "10px" }}>{file?.name}</Box>
              <Box
                onClick={() => setFile(null)}
                sx={{ paddingRight: "10px", cursor: "pointer" }}
                //  sx={{position: 'absolute', right: 0, width: '1.5rem', paddingLeft: '5px', backgroundColor: `${cssProperties?.backgroundcolor?.secondary}`}}
              >
                <PiXBold />
              </Box>
            </Box>
          ) : (
            <Box
              style={{
                border: "1px dashed gray",
                maxWidth: "330px",
                minHeight: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 340,
                position: "relative",
              }}
              onDragOver={handleDragOver}
              onDrop={handleDrop}
            >
              <input
                type="file"
                name="document"
                id="document"
                accept=".xlsx"
                alt=""
                style={{
                  width: "0.1px",
                  height: "0.1px",
                  opacity: 0,
                  overflow: "hidden",
                  position: "absolute",
                  zIndex: -1,
                }}
                onChange={handleDocumentUpload}
              />

              <label
                htmlFor="document"
                style={{
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <IoCloudUploadOutline style={{ marginLeft: "8px" }} size={22} />{" "}
                <span>
                  {" "}
                  &nbsp; Drag or drop your file, or{" "}
                  <span style={{ color: "blue" }}>&nbsp;browse</span>
                </span>
                <small style={{ color: "rgb(102, 102, 102)" }}>
                  (xlsx) (5mb max.)
                </small>
              </label>
            </Box>
          )}
          <Box
            mt={2}
            justifyContent="end"
            alignItems="center"
            display="flex"
            gap={1}
          >
            <BluePrimaryButton
              disabled={loading}
              handleSubmit={() => {
                toggleOpen();
                setFile(null);
              }}
              title="Close"
            />
            <MauvelousPrimaryButton
              disabled={loading || !file || id === 0}
              handleClick={
                open.type === "candidate"
                  ? handleUploadCandidateData
                  : handleUploadTemplate
              }
              title="Submit"
            />
          </Box>
        </Box>
      </Modal>
      <Modal
        open={statusModalopen.open}
        sx={{
          display: "flex",
          p: 1,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 5,
            // border: '2px solid #000',
            boxShadow: (theme) => theme.shadows[5],
            p: 4,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            height: 200,
          }}
        >
          <Box my={2}>
            <CircularProgress
              sx={{ color: `${cssProperties?.color?.primary}` }}
              size={50}
              thickness={2}
            />
          </Box>
          {statusModalopen.statustext}
        </Box>
      </Modal>
    </div>
  );
}
